<template>
    <div class="index-overview-income-payout">
        <div class="ah-container" style="margin-top: 10px; margin-bottom: 25px" v-if="isAuth('D14') || isAuth('D15')">
            <div class="ah-card shadow" style="padding: 20px 0 30px 0">
                <el-row :gutter="40">
                    <el-col :sm="12">
                        <PieChartWithList
                            v-if="isAuth('D14')"
                            category="收入"
                            :data="incomePieData"
                            :year="year"
                            :total-value="incomeTotal"
                            totalToolTip="發票(待入帳、完成)總額含營業稅 ＋ 營業其他收入"
                        >
                            <template slot="header">
                                <div class="sub-section-title">收入的來源</div>
                            </template>
                        </PieChartWithList>
                    </el-col>
                    <el-col :sm="12">
                        <PieChartWithList
                            v-if="isAuth('D15')"
                            category="支出"
                            :data="payoutPieData"
                            :year="year"
                            :total-value="payoutTotal"
                            totalToolTip="請款單(待確認付款、完成)總額 ＋ 人事薪資 ＋ 營業其他支出"
                            :toggle="{
                                label: '收入',
                                totalValue: incomeTotal
                            }"
                        >
                            <template slot="header">
                                <div class="sub-section-title">支出的流向</div>
                            </template>
                        </PieChartWithList>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import PieChartWithList from '@/components/ui/PieChartWithList.vue';

export default {
    components: { PieChartWithList },
    props: {
        isLoading: Boolean,

        year: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            incomePieData: [], // 營業收入
            payoutPieData: [], // 營業支出

            incomeTotal: 0,
            payoutTotal: 0,
        };
    },
    methods: {
        // 營業收入
        updateIncomeData(data) {
            // 製作給餅圖的資料 & 加總
            const { subtotals } = data;
            const chartData = [];
            if (subtotals.length === 0) return;
            // make chartData obj with name
            subtotals[0].groupInfos.forEach((infoItem) => {
                chartData.push({
                    name: infoItem.name,
                    value: 0,
                });
            });
            // sum monthly amount into chartData
            for (let m = 0; m < subtotals.length; m += 1) {
                for (let i = 0; i < subtotals[m].groupInfos.length; i += 1) {
                    chartData[i].value += subtotals[m].groupInfos[i].amount;
                }
            }
            this.incomePieData = chartData;
            this.incomeTotal = _.sumBy(chartData, 'value');
        },
        // 營業支出
        updatePayoutData(data) {
            // 製作給餅圖的資料 & 加總
            const { subtotals } = data;
            const chartData = [];
            if (subtotals.length === 0) return;
            // make chartData obj with name
            subtotals[0].groupInfos.forEach((infoItem) => {
                chartData.push({
                    name: infoItem.name,
                    value: 0,
                });
            });
            // sum monthly amount into chartData
            for (let m = 0; m < subtotals.length; m += 1) {
                for (let i = 0; i < subtotals[m].groupInfos.length; i += 1) {
                    chartData[i].value += subtotals[m].groupInfos[i].amount;
                }
            }
            this.payoutPieData = chartData;
            this.payoutTotal = _.sumBy(chartData, 'value');
        },
    },
};
</script>
<style lang="scss">
.index-overview-income-payout {
    .sub-section-title {
        display: inline-block;
        background-color: #f1f1f5;
        margin-left: 5px;
        margin-bottom: 10px;
        font-size: 10.5pt;
        font-weight: bold;
        border-radius: 4px;
        padding: 2px 12px;
        color: #515878;
    }
}
</style>
